import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { AdminRole, PermissionsMap } from '../../types/AdminTypes'

interface AdminState {
  userId: string | null
  email: string | null
  role: AdminRole | null
  permissions: PermissionsMap | null
  isLoading: boolean
  error: string | null
}

const initialState: AdminState = {
  userId: null,
  email: null,
  role: null,
  permissions: null,
  isLoading: true,
  error: null,
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setPermissions: (
      state,
      action: PayloadAction<{
        userId: string
        email: string
        role: AdminRole
        permissions: PermissionsMap
      }>
    ) => {
      state.userId = action.payload.userId
      state.email = action.payload.email
      state.role = action.payload.role
      state.permissions = action.payload.permissions
      state.isLoading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.isLoading = false
    },
    clearAdmin: (state) => {
      state.userId = null
      state.email = null
      state.role = null
      state.permissions = null
      state.isLoading = false
      state.error = null
    },
  },
})

export const { setPermissions, setLoading, setError, clearAdmin } = adminSlice.actions
export default adminSlice.reducer
